<template>
  <div ref="mapContainer" style="width: 100%; height: 500px;"></div>
</template>

<script>
export default {
  name: 'SelectTiandituPos',
  data() {
    return {
      map: null,
      marker: null,
      clickListener: null
    }
  },
  mounted() {
    this.loadTianDiTuScript().then(() => {
      console.log('加载天地图成功');
      this.initMap();
    }).catch(err => {
      console.error('加载天地图失败:', err);
    });
  },
  beforeDestroy() {
    this.cleanup();
  },
  beforeUnmount() {
    this.cleanup();
  },
  methods: {
    cleanup() {
      if (this.map) {
        // 移除地图事件监听器
        if (this.clickListener) {
          this.map.removeEventListener("click", this.clickListener);
          this.clickListener = null;
        }
        // 移除标记
        if (this.marker) {
          this.map.removeOverLay(this.marker);
          this.marker = null;
        }
        // 清理地图实例
        this.map = null;
      }
    },
    loadTianDiTuScript() {
      return new Promise((resolve, reject) => {
        // 检查是否已加载
        /* eslint-disable no-undef */
        if (window.T) {
          resolve();
          return;
        }
        /* eslint-enable no-undef */

        /* eslint-disable no-undef */
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=4c7d42787aaf263488ae749c9dcb547f`;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load TianDiTu script'));
        document.head.appendChild(script);
        /* eslint-enable no-undef */
      });
    },
    initMap(options = {}) {
      // 初始化地图
      /* eslint-disable no-undef */
      const map = new T.Map(this.$refs.mapContainer);
      // 设置中心点和缩放级别（默认为北京，或者根据传入参数）
      let centerLng = options.lng || 116.40969;
      let centerLat = options.lat || 39.897494;
      let zoom = options.zoom || 12;
      let point = new T.LngLat(centerLng, centerLat);
      let marker = new T.Marker(point);
      /* eslint-enable no-undef */
      map.addOverLay(marker);
      this.marker = marker;
      map.centerAndZoom(point, zoom);
      this.map = map;

      console.log('初始化天地图成功');

      // 添加点击事件监听器
      this.addClickEvent();
    },
    addClickEvent() {
      /* eslint-disable no-undef */
      this.clickListener = (event) => {
        const lng = event.lnglat.lng;
        const lat = event.lnglat.lat;

        // 如果存在旧标记，移除它
        if (this.marker) {
          this.map.removeOverLay(this.marker);
        }

        // 创建新标记并添加到地图
        const marker = new T.Marker(new T.LngLat(lng, lat));
        this.map.addOverLay(marker);
        this.marker = marker;

        // 触发自定义事件，将坐标传递给父组件
        this.$emit('position-change', { lng, lat });
      };
      this.map.addEventListener("click", this.clickListener);
      /* eslint-enable no-undef */
    },
    // 初始化位置
    initPosition(options = {}) {
      console.log('初始化位置');
      if (options.lng && options.lat){
        this.setPosition(options.lng, options.lat);
      }else {
        this.getPosition();
      }
    },
    // 更新位置
    setPosition(lng, lat) {
      console.log('更新位置');
      if (this.marker) {
        this.map.removeOverLay(this.marker);
      }
      /* eslint-disable no-undef */
      let point = new T.LngLat(lng, lat);
      let marker = new T.Marker(point);
      this.map.addOverLay(marker);
      this.marker = marker;
      this.map.centerAndZoom(point, 12);
      /* eslint-enable no-undef */
    },
    // 获取地理位置
    getPosition() {
      console.log('获取位置');
      // 尝试获取用户地理位置
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
              let lng = position.coords.longitude;
              let lat = position.coords.latitude;
              this.setPosition(lng, lat);
            },
            (error) => {
              console.error("获取位置失败:", error.message);
              this.$message ? this.$message.error("无法获取您的位置，请检查权限或使用支持的浏览器。") : console.error("无法获取您的位置，请检查权限或使用支持的浏览器。");
            },
            {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 60000
            }
        );
      } else {
        this.$message ? this.$message.error("您的浏览器不支持地理位置定位。") : console.error("您的浏览器不支持地理位置定位。");
      }
    }
  },
  computed: {

  }
}
</script>

<style scoped>
</style>
